type ProjectId = number | string | undefined;

export const EXECUTION_CACHE_KEYS = {
  IFC_JOBS: (projectId: ProjectId) => ["ifcJobs", projectId],
  PROCESSING_JOBS: (projectId: ProjectId) => ["processingJobs", projectId],
};
